import { useState } from "react";
import { toPng } from "html-to-image";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ExportButton({ targetRef, filename = "chart", label = "Export PNG", className = "" }) {
  const [busy, setBusy] = useState(false);
  const doExport = async () => {
    const node = targetRef?.current;
    if (!node) return;
    setBusy(true);
    try {
      const dataUrl = await toPng(node, {
        backgroundColor: "#ffffff",
        pixelRatio: 2,
        width: node.scrollWidth,
        height: node.scrollHeight,
        style: { overflow: "visible" },
        skipFonts: true,
      });
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = `${filename}.png`;
      a.click();
      toast.success("Downloaded as PNG");
    } catch (e) {
      toast.error("Export failed — please try again");
    } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={doExport} disabled={busy}
      className={`flex items-center gap-1.5 h-9 px-3 rounded-lg border border-border text-sm font-semibold text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors ${className}`}
      data-testid={`export-${filename}`}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} {label}
    </button>
  );
}
